import step01 from './step-0-1.xml?raw';
import step12 from './step-1-2.xml?raw';
import step23 from './step-2-3.xml?raw';
import step34 from './step-3-4.xml?raw';
import step45 from './step-4-5.xml?raw';
import step56 from './step-5-6.xml?raw';
import step67 from './step-6-7.xml?raw';
import step78 from './step-7-8.xml?raw';
import step89 from './step-8-9.xml?raw';
import generateOutputs from './generate-outputs.xml?raw';
import scoreResponses from './score-responses.xml?raw';
import tokenWeighting from './token-weighting.xml?raw';

export const STEP_SEQUENCES: Record<string, string> = {
  '0-1': 'blog-show-model',
  '1-0': 'blog-hide-model',
  '1-2': 'blog-show-training',
  '2-1': 'blog-hide-training',
  '2-3': 'blog-show-sampling',
  '3-2': 'blog-hide-sampling',
  '3-4': 'blog-show-scores',
  '4-3': 'blog-hide-scores',
  '4-5': 'blog-show-advantage',
  '5-4': 'blog-hide-advantage',
  '5-6': 'blog-show-grpo',
  '6-5': 'blog-hide-grpo',
  '6-7': 'blog-show-grpo-weights',
  '7-6': 'blog-hide-grpo-weights',
  '7-8': 'blog-show-gspo-weights',
  '8-7': 'blog-hide-gspo-weights',
  '8-9': 'blog-show-conclusion',
  '9-8': 'blog-hide-conclusion',
};

export const GENERATE_OUTPUTS_SEQUENCES: Record<string, string> = {
  '0-1': 'blog-generate-outputs-forward',
  '1-0': 'blog-generate-outputs-reverse',
};

export const SCORE_RESPONSES_SEQUENCES: Record<string, string> = {
  '0-1': 'blog-score-responses-forward',
  '1-0': 'blog-score-responses-reverse',
};

export const TOKEN_WEIGHTING_SEQUENCES: Record<string, string> = {
  '0-1': 'blog-token-weighting-forward',
  '1-0': 'blog-token-weighting-reverse',
};

export function injectSequences(worldElement: Element): void {
  const fragments = [step01, step12, step23, step34, step45, step56, step67, step78, step89];

  for (const fragment of fragments) {
    const temp = document.createElement('div');
    temp.innerHTML = fragment.trim();

    for (const child of Array.from(temp.children)) {
      worldElement.appendChild(child);
    }
  }
}

function injectFragment(worldElement: Element, fragment: string): void {
  const temp = document.createElement('div');
  temp.innerHTML = fragment.trim();
  for (const child of Array.from(temp.children)) {
    worldElement.appendChild(child);
  }
}

export function injectGenerateOutputsSequences(worldElement: Element): void {
  injectFragment(worldElement, generateOutputs);
}

export function injectScoreResponsesSequences(worldElement: Element): void {
  injectFragment(worldElement, scoreResponses);
}

export function injectTokenWeightingSequences(worldElement: Element): void {
  injectFragment(worldElement, tokenWeighting);
}
